
/**
 * Validates if the given string is an email or not
 *  Validates _@_._
 * @param str - string to validate
 * @returns {boolean} - whether it's valid or not
 */
export const email = (str: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str)
}